import React from 'react';
import ReactPixel from 'react-facebook-pixel';

import './GDPRpopup.scss';

export default class GDPRpopup extends React.PureComponent {
  state = {
    showPopup:
      document.cookie.replace(/(?:(?:^|.*;\s*)ga_gdpr\s*=\s*([^;]*).*$)|^.*$/, '$1') !== 'yes' &&
      document.cookie.replace(/(?:(?:^|.*;\s*)ga_gdpr\s*=\s*([^;]*).*$)|^.*$/, '$1') !== 'no',
    checkboxChecked: false
  };

  gtag = args => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(args);
  };

  changeHandler = e => {
    this.setState({ checkboxChecked: e.target.checked });
  };

  clickHandler = () => {
    const thirtyDaysInMiliseconds = 1440 * 30 * 60 * 1000;
    const inThirtyDays = new Date(new Date().getTime() + thirtyDaysInMiliseconds);
    if (this.state.checkboxChecked) {
      document.cookie = `ga_gdpr=yes; expires=${inThirtyDays}; path=/`;
      this.setState({ showPopup: false });
      window.location.reload(false);
    } else {
      document.cookie = `ga_gdpr=no; expires=${inThirtyDays}; path=/`;
      ReactPixel.revokeConsent();
      this.setState({ showPopup: false });
    }
  };

  render() {
    return (
      <section className={`gdpr-wrapper${this.state.showPopup ? '' : '--hidden'}`}>
        <div id="GDPRcontent">
          <div className="gdpr-text-wrapper">
            <p className="gdpr-text">
              This web site is using Cookies and Google Analytics. If you agree to collect statistic
              data, please mark the checkbox Performance cookies and confirm with button OK. You may
              review our Cookies Policy{' '}
              <a
                className="cookie-link"
                href="https://www.accenture.com/sk-sk/company-cookies-similar-technology"
                rel="noopener noreferrer"
                target="_blank">
                here
              </a>
              .
            </p>
            <label className="gdpr-checkbox-label">
              <input checked className="gdpr-checkbox" disabled type="checkbox" />
              Necessary cookies
            </label>
            <label className="gdpr-checkbox-label">
              <input className="gdpr-checkbox" onChange={this.changeHandler} type="checkbox" />
              Performance cookies
            </label>
          </div>
          <div className="gdpr-button-wrapper">
            <button
              className="gdpr-button button is-rounded"
              id="gdpr_accept_btn"
              onClick={this.clickHandler}
              type="button">
              OK
            </button>
          </div>
        </div>
      </section>
    );
  }
}
